import React from 'react';
import PropTypes from 'prop-types';
import { chakra, ChakraProvider, Flex } from '@chakra-ui/react';
import Head from '@repo/ui-components/Head';
import { GlobalStyles } from '@utils/GlobalStyles';
import Cart from '@repo/ui-components/dept/organisms/Cart';
import CartToast from '@repo/ui-components/dept/organisms/Cart/CartToast';
import Logo from '@repo/ui-components/dept/atoms/Logo';
import Link from '@repo/ui-components/tailwind/Link';
import useSiteSettingsContext from '@components/hooks/useSiteSettingsContext';
import { usePetsafeInternationalContext } from '@util/static-translations';
import ChakraTheme from '../../@chakra-ui/gatsby-plugin/theme';
import '../../styles/globals.css';

const links = [];

function SimpleLayout({ children, headTagData, linkHreflangValues }) {
  const { siteSettings } = useSiteSettingsContext();
  const { locale } = usePetsafeInternationalContext();

  return (
    <ChakraProvider theme={ChakraTheme}>
      <Head
        title={headTagData.title}
        description={headTagData.description}
        keywords={headTagData.keywords}
        meta={headTagData.meta}
        noIndex={headTagData?.noIndex}
        noFollow={headTagData?.noFollow}
        linkTags={links}
        lang={locale}
        hreflangs={linkHreflangValues}
      >
        <script key="google-tag-manager" async>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${process.env.GATSBY_GTM_ID}');`}
        </script>
      </Head>
      <GlobalStyles />
      <Cart freeShippingThreshold={siteSettings.shipping} />
      <CartToast />
      <header>
        <Flex
          pos="relative"
          bg="brand.ink"
          mx="auto"
          mb={10}
          maxW="1680px"
          justifyContent="center"
          alignItems="center"
          borderBottomRightRadius={{ base: 0, xl: 'lg' }}
          borderBottomLeftRadius={{ base: 0, xl: 'lg' }}
          h="5rem"
        >
          <nav>
            <Link link="/">
              <Logo yellow width={{ base: '150px' }} />
            </Link>
          </nav>
        </Flex>
      </header>
      <chakra.main id="main">{children}</chakra.main>
    </ChakraProvider>
  );
}
SimpleLayout.defaultProps = {
  headTagData: {
    noIndex: false,
    noFollow: false,
  },
  linkHreflangValues: [],
};

SimpleLayout.propTypes = {
  children: PropTypes.node.isRequired,
  headTagData: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    canonicalUrl: PropTypes.string,
    keywords: PropTypes.string,
    meta: PropTypes.arrayOf(PropTypes.shape({})),
    productSchema: PropTypes.string,
    noIndex: PropTypes.bool,
    noFollow: PropTypes.bool,
  }),
  linkHreflangValues: PropTypes.arrayOf(PropTypes.shape({})),
};

export default SimpleLayout;
